import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {ISorguSonuc} from "./CommonInterfaces";

export interface BagkurEmekliTalep {
    dosyaId: string,
    kisiKurumId: number,
}

export interface BagkurEmekliCevap extends ISorguSonuc<IBagkurEmekliSonuc>{}

export interface IBagkurEmekliSonuc {
    emekliKaydi4AList: IEmekliKaydi4B,
    hataKodu: 0 | 995,      // başarılı | kayıt bulunamadı
    hataMesaji: string
}

export interface IEmekliKaydi4B {
    aylikGoruntuleForm: Array<IAylikGoruntuleForm>,
    sonucKod: number,
    sonucMesaj: string
}

export interface IAylikGoruntuleForm {
    adi: string,
    aylikBaslangicTarihi: string,
    aylikNevi: string,
    bankaAdi: string,
    brut_aylik: string,
    dogumTarihi: string,
    durumKodu: number,
    durumKoduString: string,
    ekOdeme_Tutari: string,
    makamTazminati_Tutari: string,
    odemeDonemi: string,
    onayDurumu: number,
    onayDurumuString: string,
    saglikKesinti_Tutari: string,
    sgmAdi: string,
    sicilNo: string,
    soyAdi: string,
    subeAdi: string,
    tahsisDosyaNo: number,
    tahsisIlAdi: string,
    talepTarihi: string,
    tcKimlikNo: string,
    toplam: string,
    yakinlik: string,
    yurtDisi: string
}

export class BagkurEmekli extends UyapRequest<BagkurEmekliTalep, BagkurEmekliCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Bağkur emekli bilgileri sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "BagkurEmekli_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"4********10","adi":"AH**** MÜ***","soyadi":"YA*******","babaAdi":"A*********","anaAdi":"Ş*****","dogumTarihiStr":"1957","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":28698317,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 2. Genel İcra Dairesi","birimId":"1000963","orgKodu":"1.04.011.000.6037","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/27440","dosyaNoYil":2023,"dosyaSira":27440,"dosyaId":"013@RlwAzAkR3QHUdOJ2Iv5aU9TJdIwHQeNEiGegO8kf7nAi1KI1KsqcLTgV6Aw8","dosyaAcilisTarihi":"08/07/2023 10:35","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ABDULSELAM DENİZ, AHMETİ MÜNÜR YALÇINALP","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"26/07/2024 14:46","sorguSonucDVO":{"emekliKaydi4B":{"aylikGoruntuleForm":[{"adi":"AHMETİ MÜNÜR","aylikBaslangicTarihi":"01/09/2019","aylikNevi":"Yaşlılık  Aylığı","bankaAdi":"İŞ BANKASI                                        ","brut_aylik":"9.615,38","dogumTarihi":"25/08/1957","durumKodu":1,"durumKoduString":"Birinci Karar Yapıldı","ekOdeme_Tutari":"384,62","makamTazminati_Tutari":"0.00","odemeDonemi":"27/07/2024","onayDurumu":6,"onayDurumuString":"Ödeme durumda ","saglikKesinti_Tutari":"0.00","sgmAdi":"RÜZGARLI SOSYAL GÜVENLİK MERKEZİ","sicilNo":"1173483581     ","soyAdi":"YALÇINALP","subeAdi":"DEMETEVLER ŞB.","tahsisDosyaNo":2948354,"tahsisIlAdi":"6","talepTarihi":"26/08/2019","tcKimlikNo":"47161224210","toplam":"10.000,00","yakinlik":"Kendisi","yurtDisi":"Hayır"}],"sonucKod":0,"sonucMesaj":""},"hataKodu":0,"hataMesaji":""},"sorgulamaTuru":"Bağkur Emeklisi","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_sgk_bagkurEmekliBilgileri.ajx';
    }

    async parse(data: any): Promise<BagkurEmekliCevap> {
        if (data.sorguSonucDVO?.hataKodu == 995) {
            data.message = data.sorguSonucDVO.hataMesaji;
            data.sorguSonucu = false;
        } else
            data.message = "Sorgulama başarılı";
        return data;
    }

}

export default BagkurEmekli;
